const UNRESOLVED_KEYS = new Set(["headerFontStyle", "baseFontStyle", "markerFontStyle", "editorFontSize"]);
/**
 * Canvas cannot read CSS variables, so values are applied to a hidden probe element and read
 * back computed: `var()` chains and scoped tokens resolve from the probe's position in the DOM,
 * and colours come back as `rgb()` even when authored as `color-mix()` or a named colour.
 */
export const createCssResolver = (probe) => {
    const cache = new Map();
    const probeValue = (property, value) => {
        const key = `${property}|${value}`;
        const hit = cache.get(key);
        if (hit !== undefined)
            return hit;
        probe.style[property] = value;
        const out = getComputedStyle(probe)[property] || value;
        probe.removeAttribute("style");
        cache.set(key, out);
        return out;
    };
    return {
        color: (value) => probeValue("color", value),
        fontFamily: (value) => probeValue("fontFamily", value),
    };
};
export const resolveTheme = (theme, resolver) => {
    const out = {};
    for (const [key, value] of Object.entries(theme)) {
        if (typeof value !== "string" || UNRESOLVED_KEYS.has(key))
            out[key] = value;
        else
            out[key] = key === "fontFamily" ? resolver.fontFamily(value) : resolver.color(value);
    }
    return out;
};
export const resolveCell = (cell, resolver) => cell.themeOverride ? { ...cell, themeOverride: resolveTheme(cell.themeOverride, resolver) } : cell;
//# sourceMappingURL=cssTheme.js.map